import React, { useEffect, useState } from 'react';

const TestingPage = () => {
  return (
    <div>
      <h3>Testing things</h3>
    </div>
  );
};

export default TestingPage;
